// @ts-nocheck
import type { ReactNode } from 'react';
import type { AnalysisData } from '../../../services/AnalysisApiClient';
import { useClientPageSummaryBadges } from '../hooks/useClientPageSummaryBadges';
import { ClientWorkflowSummaryBadges } from './ClientWorkflowSummaryBadges';

/** Intro text (left) + deal summary badges (right) — analyses, run history, workflow overview. */
export function ClientPageSummaryBar({
  intro,
  formData,
  className = '',
}: {
  intro: ReactNode;
  /** Workflow overview passes live form data; omit on list pages. */
  formData?: AnalysisData | null;
  className?: string;
}) {
  const { summaryBadges } = useClientPageSummaryBadges(formData);

  return (
    <div
      className={`flex flex-col gap-3 border-b border-gray-100 pb-4 md:flex-row md:items-start md:justify-between md:gap-6 ${className}`.trim()}
    >
      <div className="min-w-0 flex-1 max-w-2xl space-y-2 text-sm leading-snug text-gray-600 sm:text-base">{intro}</div>
      <div className="shrink-0 self-start">
        <ClientWorkflowSummaryBadges badges={summaryBadges} />
      </div>
    </div>
  );
}
